import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import ButtonComp from "../Button/Index";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { buildExportData, getAllHeaders, getExportRows, styleWorksheet } from "@utils/formulario/exportDataToExcel";

const ExportToExcelButton = ({ data, fileName, sheetName }) => {

    const handleExport = async () => {
        if (!Array.isArray(data) || data.length === 0) {
            SweetAlert.toastInfo("Não há dados para exportar!");
            return;
        }

        const warning = await SweetAlert.warning(
            "Atenção!",
            "Deseja realmente exportar os dados atuais da tabela para um arquivo .xlsx (Excel)?"
        );
        if (!warning) return;

        try {
            SweetAlert.loading();

            const exportData = buildExportData(data);
            const headers = getAllHeaders(exportData);
            const rows = getExportRows(exportData, headers);

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(sheetName || 'Planilha1');

            worksheet.addRow(headers);
            rows.forEach(row => worksheet.addRow(row));
            styleWorksheet(worksheet, headers);

            // Gera o arquivo e faz download
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);

            await SweetAlert.close();
            setTimeout(() => {
                SweetAlert.success("Exportado!", "Arquivo exportado com sucesso.");
            }, 100);

        } catch (e) {
            SweetAlert.close();
            setTimeout(() => {
                SweetAlert.error("Erro", "Falha ao exportar o arquivo para Excel.");
            }, 100);
        }
    };

    return (
        <div>
            <ButtonComp
                title={"Exportar para Excel"}
                buttonColor={"#125578"}
                classnameIcon={"fa-solid fa-file-excel"}
                hoverMessage={"Botão para exportar os dados atuais da tabela para o excel"}
                className="btn btn-success"
                onClick={handleExport}
            />
        </div>
    );
};

export default ExportToExcelButton;
